import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";

interface BookingsFilteredBannerProps {
  onClearFilters: () => void;
}

const BookingsFilteredBanner = ({
  onClearFilters,
}: BookingsFilteredBannerProps) => (
  <div className="bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
    <Search className="h-12 w-12 text-gray-400 mx-auto mb-4" />

    <h3 className="text-gray-800 font-medium mb-2">
      No se encontraron resultados
    </h3>

    <p className="text-gray-600 text-sm mb-4">
      No hay reservaciones que coincidan con los filtros aplicados.
    </p>

    <Button variant="outline" onClick={onClearFilters}>
      Limpiar filtros
    </Button>
  </div>
);

export default BookingsFilteredBanner;
